import React, { useState, useCallback, useContext } from 'react';
import { createUseStyles, Input, Textarea, Button, Advice } from '@Sage/hoi-poi-ui';
import { URL_REGEX } from "../../../../../utils/string";
import { a2aInfo } from "../../../../../lib/services/copilotAgents";
import { CopilotContext } from "../../../Context";
import CopilotSidebarTabHeader from "../../components/CopilotSidebarTabHeader";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotSidebarAgentsRemoteForm');
var _ref3 = /*#__PURE__*/React.createElement(Advice, {
  type: "semanticInfo",
  title: "\u2728 Let's bring your agent to life!",
  showIcon: true,
  defaultCollapsed: false
}, "Connect an existing agent by pasting its URL! \uD83D\uDE80 We'll automatically fetch the details from A2A-compatible sources.");
const CopilotSidebarAgentsRemoteForm = _ref => {
  let {
    agent,
    onCancel,
    onSave
  } = _ref;
  const classes = useStyles();
  const {
    refreshAgents
  } = useContext(CopilotContext);
  const [isLoading, setIsLoading] = useState(false);
  const [url, setUrl] = useState(agent === null || agent === void 0 ? void 0 : agent.url);
  const [info, setInfo] = useState(agent ? {
    name: agent === null || agent === void 0 ? void 0 : agent.name,
    description: agent === null || agent === void 0 ? void 0 : agent.description
  } : undefined);
  const [error, setError] = useState(null);
  const onInnerCancel = useCallback(() => {
    onCancel();
    setTimeout(() => {
      setUrl();
      setError();
      setInfo();
    });
  }, [onCancel]);
  const loadURL = useCallback(() => {
    if (url && !URL_REGEX.test(url)) {
      setError('Agent URL is not valid');
      setInfo();
    } else if (url) {
      setError(null);
      a2aInfo(url).then(_ref2 => {
        let {
          data
        } = _ref2;
        setInfo(data);
      }).catch(err => {
        console.error(err);
        setError('Error fetching agent info. Please provide a compatible agent URL source.');
      });
    }
  }, [url]);
  const onInnerSave = useCallback(() => {
    setIsLoading(true);
    onSave({
      url
    }).then(() => {
      onInnerCancel();
    }).finally(() => {
      setIsLoading(false);
      refreshAgents();
    });
  }, [onInnerCancel, onSave, refreshAgents, url]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(CopilotSidebarTabHeader, {
    title: agent !== null && agent !== void 0 && agent.id ? 'Edit agent' : 'Create agent',
    onBack: onInnerCancel,
    sideComponent: /*#__PURE__*/React.createElement(Button, {
      type: "primary",
      onClick: onInnerSave,
      isLoading: isLoading,
      isDisabled: !url
    }, "Save")
  }), _ref3, /*#__PURE__*/React.createElement(Input, {
    label: "URL Agent",
    placeholder: "Paste here the URL where you create the agent",
    value: url,
    onChange: setUrl,
    onEnter: loadURL,
    onBlur: loadURL,
    error: error,
    isFullWidth: true,
    isRequired: true
  }), info && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, {
    label: "Name",
    value: info.name,
    isFullWidth: true,
    isReadOnly: true
  }), /*#__PURE__*/React.createElement(Textarea, {
    label: "Description",
    value: info.description,
    minRows: 2,
    maxRows: 4,
    isResizable: false,
    isFullWidth: true,
    isReadOnly: true
  })));
};
export default CopilotSidebarAgentsRemoteForm;